import React from 'react'
import { WMSTileLayer } from 'react-leaflet'

function EcuadorZaeeCafeLayer({ opacity = 0.6 }) {
  return (
    <WMSTileLayer
      layers="vw_zaee_cafe"
      format="image/png"
      version="1.1.1"
      transparent
      tiled
      url={`https://g8a078u1g6.execute-api.eu-west-1.amazonaws.com/app/wms-ecuador/demarcacion/E250k/wms`}
      opacity={opacity}
    />
  )
}

export default EcuadorZaeeCafeLayer
